import React from 'react'
import SbEditable from 'storyblok-react'

export interface ImageProps {
  blok: StoryblokComponent & {
    image: string
  }
}

export const Image = ({ blok }: ImageProps) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''

  return (
    <div
        className="max-w-full flex items-center justify-center"
      style={{
        marginTop: marginTopClass,
        marginBottom: marginBottomClass,
      }}
    >
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <img src={blok.image} className="w-[1520px] content-center object-contain" />
      </SbEditable>
    </div>
  )
}

Image.displayName = 'Image'